import { Component } from '@angular/core';

@Component({
  selector: 'ngx-auth-title-section',
  templateUrl: 'auth-title-section.component.html',
  styleUrls: ['auth-title-section.component.scss'],
})
export class AuthTitleSectionComponent {}
